"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeletePassport = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var passport_1 = require("../../actions/passport");
var commonweb_utils_1 = require("commonweb-utils");
var constants_1 = require("../../constants");
var ajax_util_1 = require("../../utils/ajax/ajax.util");
var pp_react_1 = require("@paypalcorp/pp-react");
var ROUTES = constants_1.default.ROUTES, VIEWS = constants_1.default.VIEWS;
var page = require("page");
var DeletePassport = /** @class */ (function (_super) {
    tslib_1.__extends(DeletePassport, _super);
    function DeletePassport(props) {
        var _this = _super.call(this, props) || this;
        _this.showPassportCountry = function (passportContent, passportInfo) {
            if (passportInfo.passportCountry) {
                return (React.createElement("div", null,
                    React.createElement(pp_react_1.Text, { className: "generic-message passport-label", size: "md" }, passportContent.issuingCountry.label),
                    React.createElement(pp_react_1.Text, { className: "generic-message passport-label", size: "md", regular: true }, passportInfo.passportCountry)));
            }
        };
        _this.submitHandler = function (event) {
            event.preventDefault();
            var _a = _this.props, dispatch = _a.dispatch, _csrf = _a._csrf;
            ajax_util_1.default.delete$(dispatch, _csrf, "" + ROUTES.API.PASSPORT.DELETE, {}, { component: { name: VIEWS.DELETE_PASSPORT } })
                .then(function (passportInfo) {
                if (passportInfo) {
                    dispatch(passport_1.changePassport(passportInfo));
                }
                page.redirect(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PASSPORT.DELETE_SUCCESS);
            })
                .catch(function (error) {
                _this.setState({
                    errorMessage: _this.props.content.passport.genericError,
                });
                return;
            });
        };
        _this.state = {
            errorMessage: "",
        };
        return _this;
    }
    DeletePassport.prototype.render = function () {
        var showSpinner = this.props.ui.showSpinner, passportContent = this.props.content.passport, passportInfo = this.props.passport || {}, cancelLink, isFlow = this.props.route.isFlow || false, flowName = this.props.route.enter.flow || "";
        if (isFlow) {
            cancelLink = constants_1.default.BASE_URI + "/flow-return/" + flowName;
        }
        else {
            cancelLink = "" + constants_1.default.BASE_URI;
        }
        if (passportInfo.passportNumber) {
            return (React.createElement("div", { className: "generic-container" }, showSpinner ? (React.createElement("div", { className: "panelSpinner" })) : (React.createElement("form", { onSubmit: this.submitHandler },
                this.state.errorMessage ? (React.createElement(pp_react_1.Alert, { type: "error", className: "form-alert" }, this.state.errorMessage)) : null,
                React.createElement(pp_react_1.Text, { className: "generic-header passport-header", size: "xl3" }, passportContent.remove.header),
                React.createElement(pp_react_1.Text, { className: "generic-message passport-label", size: "md" }, passportContent.passport.label),
                React.createElement(pp_react_1.Text, { className: "generic-message passport-label", size: "md", regular: true }, passportInfo.passportNumber),
                this.showPassportCountry(passportContent, passportInfo),
                React.createElement(pp_react_1.Text, { className: "generic-message remove-passport-confirm", size: "md" }, passportContent.remove.question),
                React.createElement(pp_react_1.Button, { id: "test_remove_passport", className: "passport-button", type: "submit", name: "passportDeleteSubmit" }, this.props.content.common.remove),
                React.createElement(pp_react_1.Link, { id: "test_cancel_remove", href: cancelLink, target: "_self", onClick: this.props.transitionOutHandler, "data-name": "cancel" }, this.props.content.common.cancel)))));
        }
        else {
            return (React.createElement("div", { className: "generic-container" },
                React.createElement(pp_react_1.Alert, { type: "error", className: "form-alert" }, passportContent.genericError)));
        }
    };
    return DeletePassport;
}(React.Component));
exports.DeletePassport = DeletePassport;
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account;
    var passport = commonweb_utils_1.objectUtils.safeGet(account, "passport") || {};
    return {
        _csrf: _csrf,
        ui: ui,
        content: content,
        route: route,
        passport: passport,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchPassportChange: function (passportInfo) {
            return dispatch(passport_1.changePassport(passportInfo));
        },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(DeletePassport);
